var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.report !== null)?_c('report-view',{attrs:{"report":_vm.report}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }